<template>
  <div class="px-2 py-2 xl:py-4 lg:py-6 max-w-xl mx-auto min-h-50">
    <div class="mx-auto mb-4 overflow-hidden">
      <div class="flex flex-wrap mt-6 mx-1">
        <div class="signin w-full flex justify-center sm:justify-end min-h-xl">
          <div class="w-full pt-3">
            <div class="dialog__header">
              <h5 class="text-NotoSansBold text-center leading-loose textColorRed text-xl md:text-2xl">
                取消訂閱LiveABC電子報
              </h5>
            </div>
            <div class="dialog__body">
              <form class="bg-white rounded px-2 sm:px-12 py-6" method="POST">
                <div class="md:flex md:items-center mb-6 textColorBlack">
                  <div class="md:w-1/3">
                    <label class="block md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular" for="email">
                      Email
                    </label>
                  </div>
                  <div class="md:w-2/3">
                    <input type="email" class="text-sm input-text appearance-none border rounded borderColordarkgray2 w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                    id="username" placeholder="請輸入Email" v-model="email" autocomplete="off" name="email" />
                  </div>
                </div>
                <div class="flex items-center px-0 justify-center md:justify-end">
                    <button class="cursor-pointer text-sm button-red text-white py-2 px-6 rounded outline-none focus:outline-none w-full md:w-auto text-NotoSansRegular mb-4 sm:mb-0"
                      type="button" @click="unsubscribe" id="btnLogin">
                      取消訂閱
                    </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Regex from '@/components/modules/regex'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'Unsubscribe',
  data () {
    return {
      email: ''
    }
  },
  components: {
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    unsubscribe () {
      let self = this
      if (self.email && self.rexEmail(self.email)) {
        axios.delete(`/subscribe/epaper/${self.email}`)
          .then(() => {
            self.alertPop('success', '已取消訂閱')
            // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '已取消訂閱', type: 'check' })
            self.$router.push({ name: 'index' })
          })
          .catch(() => {
            self.alertPop('error', '發生錯誤!!')
            // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '發生錯誤!!', type: 'alert' })
            self.$router.push({ name: 'index' })
          })
      } else {
        self.alertPop('warning', '尚未填寫或格式不正確')
        // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '尚未填寫或格式不正確', type: 'alert' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box1 img{
  -webkit-box-reflect:below 0 -webkit-linear-gradient(top,rgba(250,250,250,0),rgba(250,250,250,.0) 30%,rgba(250,250,250,.3));
}
.dialog__body {
  .fb-btn {
    background-color: #3b5998;
    &:hover {
      background-color: #29487d;
    }
  }
  #my-signin2{
    .abcRioButtonContentWrapper {
      display: flex;
      justify-content: center;
    }
    width: 100% !important;
    .abcRioButton, .abcRioButtonBlue {
      background-color: white;
      width: 100% !important;
      height: 40px !important;
      border-radius: 0.25rem !important;
      height: auto;
      &:hover {
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
      }
      .abcRioButtonContents {
      font-weight: 700 !important;
      font-size: 1rem !important;
      color: black;
      }
    }
  }
  .social-login-option:before, .social-login-option:after {
      background-color: #dde1e4;
      content: "";
      display: inline-block;
      height: 1px;
      position: relative;
      vertical-align: middle;
      width: 45%;
  }
  .social-login-option:before {
    right: .5rem;
  }
  .social-login-option:after {
    left: .5em;
  }
}

.input-text {
  background-color: white;
  border: 1px solid #cccccc;
  padding: 8px 4px;
  position: relative;
  width: 100%;
  z-index: 3;
}

.label-helper {
  position: absolute;
  opacity: 0;
  transition: .2s bottom, .2s opacity;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.input-text:focus + .label-helper, .input-text:invalid + .label-helper {
  bottom: 95%;
  line-height: 1;
  opacity: 1;
  }

.input-text:not(:placeholder-shown) ~ label,
.input-text:-webkit-autofill ~ label
{
  bottom: 95%;
  line-height: 1;
  opacity: 1;
}
</style>
